import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { createSelector } from 'reselect';
import { toggleEditTableItemModal } from '../../slices/modals/reducer';
import { setSelectedItem } from '../../slices/folder/reducer';
import { updateItem } from '../../slices/folder/thunk';

function EditTableItemModal() {
  const dispatch = useDispatch();
  const selectModalState = createSelector((state) => state, (state) => ({
    modalState: state.Modal.editTableItemModal,
    selectedTableItem: state.Folder.selectedTableItem
  }));
  const {modalState, selectedTableItem} = useSelector(selectModalState);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    setEditData(selectedTableItem);
  }, [selectedTableItem]);

  function submitEditModal() {
    dispatch(setSelectedItem(editData));
    dispatch(updateItem(editData));
    dispatch(toggleEditTableItemModal());
  }

  function handleChange(e) {
    const value = e.target.value;
    setEditData((prevValue) => {
      return {
        ...prevValue,
        name: value
      }
    });
  }

  return (
    <Modal isOpen={modalState} toggle={() => dispatch(toggleEditTableItemModal())} centered size='sm'>
      <ModalHeader className='p-3' toggle={() => dispatch(toggleEditTableItemModal())}>
        <b>Edit</b>
      </ModalHeader>
      <ModalBody className='px-3'>
        <Label>Name</Label>
        <Input type='text' name='name' onChange={handleChange} value={(editData?.name || "")} /> 
      </ModalBody>
      <ModalFooter className='px-3'>
        <button className='btn btn-light' onClick={() => dispatch(toggleEditTableItemModal())}>Close</button>
        <button className='btn btn-success' onClick={submitEditModal}>Edit Name</button>
      </ModalFooter>
    </Modal>
  )
}

export default EditTableItemModal;
